<div class="wrapper" fxLayout="column" [style.background-color]="headerBgColour"
  [style.padding-bottom]="titleDescription ? '7px' : '2px'" [style.padding]="isLarge ? '15px 30px' : '0 15px'"
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <div mat-dialog-title class="margin-none force" [ngClass]="{ bold: !isLarge }"
        [ngStyle]="{ 'font-size': isLarge ? '30px' : '' }" [style.color]="headerTextColour">
        {{ dialogTitle }}
      </div>
      <small *ngIf="titleDescription" style="color: white; font-weight: bold">{{ titleDescription }}</small>
    </div>
    <div class="button-container">
      <button mat-icon-button mat-dialog-close class="action-button" (click)="dialogClosed()">
        <mat-icon style="position: relative; color: white">close</mat-icon>
      </button>
    </div>
  </div>
</div>
<mat-progress-bar *ngIf="showProgress" mode="determinate" [value]="percentProgress.value" class="green-progress">
</mat-progress-bar>

<div fxLayout="row" fxLayoutAlign="space-between center">
  <div [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'" class="page-body container-col-flex-max"
    style="max-height: 90vh; position: relative">
    <div *ngIf="modeUpload" class="file-upload-container mat-elevation-z4">
      <h2 class="upload-header">
        {{ 'DRIVER_IMPORT.intro' | translate }} <a href='#' matTooltip='Go to Import History'
          class='import-history-link'> {{ 'DRIVER_IMPORT.introImportHistory' | translate }} </a> {{
        'DRIVER_IMPORT.introEnd' | translate }}
      </h2>
      <hr class="grey-divider" />
      <div fxLayout="row" fxLayoutAlign="space-between" style="width: 100%">
        <div fxLayout="column" fxFlex="50%">
          <mat-form-field appearance="outline" class="config-select-field">
            <mat-label>{{ 'DRIVER_IMPORT.selectConfiguration' | translate }}</mat-label>
            <mat-select [(value)]="selectedConfig" required
              [placeholder]="'DRIVER_IMPORT.selectConfiguration' | translate">
              <mat-option value="Current Configuration">
                {{ 'DRIVER_IMPORT.currentConfiguration' | translate }}
              </mat-option>
              <mat-option value="Standared Configuration">
                {{ 'DRIVER_IMPORT.standaredConfiguration' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="config-select-field">
            <mat-label> {{'DRIVER_IMPORT.selectYourImportType' | translate}}</mat-label>
            <mat-select [(value)]="selectedImportType" required>
              <mat-option *ngFor="let type of importTypes" [value]="type.value">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="40%">
          <div *ngIf="onError" class="errorMessage">
            <mat-error>
              {{ 'MESSAGESANDWARNINGS.uploadCsvFile' | translate }}
            </mat-error>
          </div>
          <vrm-file-uploader (selectionError)="unSupportedFileTypeError($event)"
            [config]="fileUploadConfig"></vrm-file-uploader>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center" style="width: 100%">
        <button mat-button (click)="uploadDrivers()" class="btn-save" [disabled]="!uploadAvailable"
          [style.background-color]="'#' + cService.userProfile?.HqColour">
          {{'DRIVER_IMPORT.uploadFile' | translate | uppercase}}
        </button>
      </div>
    </div>
    <div *ngIf="!modeUpload" class="file-upload-container mat-elevation-z4">
   
      <h2 class="upload-header">

        {{ 'DRIVER_IMPORT.uploadHead' | translate }}

      </h2>
   
      <div *ngIf="!showNewColumnTextBox" class="section-title">{{ 'DRIVER_IMPORT.fileImportConfiguration' | translate }}
      </div>
      <div *ngIf="showNewColumnTextBox" class="section-title">{{'DRIVER_IMPORT.addColumnFromOrigin' | translate}}</div>
      <div style="clear: right;"></div>
      <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="!showNewColumnTextBox"
      class="driver-import-container"
    >

      <div fxLayout="column" fxFlex="40%" class="left-section">
        <mat-checkbox (change)="rePopulateRows()" [(ngModel)]="hasHeaderRow" color="primary">
          {{ 'DRIVER_IMPORT.driverImportHasHeaderRow' | translate }}
        </mat-checkbox>
    
        <div class="form-group">
          <mat-label class="form-label">
            {{ 'DRIVER_IMPORT.numberOfRowsToSkip' | translate }}
          </mat-label>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput [(ngModel)]="skipRows" class="num" type="number"/>
          </mat-form-field>
        </div>
      </div>
    

      <div fxLayout="column" fxFlex="40%" class="right-section">
        <div class="form-group">
          <mat-label class="form-label">
            {{ 'DRIVER_IMPORT.importType' | translate }}
          </mat-label>
          <mat-form-field appearance="outline" class="form-field">
            <mat-select [(value)]="selectedImportType" required>
              <mat-option *ngFor="let type of importTypes" [value]="type.value">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
    
        <div class="form-group">
          <mat-label class="form-label">
            {{ 'DRIVER_IMPORT.sampleDriverDataFile' | translate }}
          </mat-label>
          <vrm-file-uploader
            (selectionError)="unSupportedFileTypeError($event)"
            [config]="sampleUploadConfig"
          ></vrm-file-uploader>
        </div>
      </div>
    </div>

      <div style="max-height: 290px; overflow-y: scroll" >
        <div *ngIf="showNewColumnTextBox">
          <table>
            <tr><td>      <mat-form-field appearance="outline" style="margin-right: 8px">
              <mat-label> {{ 'DRIVER_IMPORT.newColumn' | translate }}</mat-label>
              <input matInput [(ngModel)]="newColumnName" class="add-new-text" placeholder="Enter column name" />
            </mat-form-field></td>
            <td colspan="2">
              <div class="action-buttons" fxLayout="row" fxLayoutAlign="space-between center">
                <button mat-button class="action-btn danger" (click)="showNewColumnTextBox = false">{{ 'GENERIC.cancel' |
                  translate }}</button>
                <button class="action-btn" mat-button vrm-button
                  [style.background-color]="'#' + cService.userProfile?.HqColour" (click)="addColumn()">
                  {{ 'GENERIC.ok' | translate | uppercase }}
                </button>
              </div>
            </td>
          </tr>
          </table>
    
        </div>
        <vrm-field-mapping-table   *ngIf="!showNewColumnTextBox"
        [rows]="rows"
        [columnDefs]="columnDefs"
        [displayedColumns]="displayedColumns"
        [dropDownItemsOrigin]="dropDownItemsOrigin"
        [dropDownItemsDestination]="dropDownItemsDestination"
        (rowUpdated)="onRowUpdated($event)"
        (rowDeleted)="onRowDeleted($event)"
        (newRowAdded)="onAddNewRow()"
        (newColumnAdded)="onAddNewColumn()"
      ></vrm-field-mapping-table>
      </div>
      <button mat-button (click)="onSaveConfiguration()" class="btn-save" *ngIf="!showNewColumnTextBox" [disabled]="modeUpload"
        [style.background-color]="'#' + cService.userProfile?.HqColour">

        {{ 'FORM.save' | translate }}
      </button>
    </div>
  </div>
</div>